import { getCountryCode, getFlagIconClass, hasFlag } from '@core/utils/countryFlag'

/**
 * Country flag mixin
 * Provides methods for working with country flags in lottery systems
 *
 * Usage:
 * import { countryFlagMixin } from '@core/mixins/ui/countryFlag'
 *
 * export default {
 *   mixins: [countryFlagMixin],
 *   // Now you can use this.getCountryCode(), this.getFlagIconClass(), this.hasFlag()
 * }
 */

// eslint-disable-next-line import/prefer-default-export
export const countryFlagMixin = {
  methods: {
    /**
     * Get country code from lottery name
     * @param {string} huayName - Lottery name
     * @returns {string|null} - Country code (ISO 3166-1 alpha-2) or null if not found
     */
    getCountryCode(huayName) {
      return getCountryCode(huayName)
    },

    /**
     * Get flag icon class name for lottery
     * @param {string} huayName - Lottery name
     * @returns {string} - CSS class name for flag icon (e.g., 'flag-icon-kr')
     */
    getFlagIconClass(huayName) {
      return getFlagIconClass(huayName)
    },

    /**
     * Check if lottery has a flag icon
     * @param {string} huayName - Lottery name
     * @returns {boolean} - True if lottery has a flag icon
     */
    hasFlag(huayName) {
      return hasFlag(huayName)
    },
  },
}
